module.exports = __webpack_public_path__ + "img/phone-white.3a0c31e9.png";